import { NgModule, Injectable } from '@angular/core';
import { RouterModule, Routes }  from '@angular/router';
import { HomeViewComponent }   from './home-view/home-view.component';
import { TableViewComponent } from './table-view/table-view.component';
import { ViewWithNavBarComponent } from './view-with-nav-bar/view-with-nav-bar.component';
import { SplashPageComponent } from './splash-page/splash-page.component';
import { ProjectViewComponent } from './project-view/project-view.component';
import { ImageGalleryViewComponent } from './image-gallery-view/image-gallery-view.component';
import { PageComponent } from './page/page.component';

const appRoutes: Routes = [
  { 
    path : '',
    component: ViewWithNavBarComponent,
    data: {
      title: 'Home'
    },
    children: [
      { path: '', component: HomeViewComponent }
    ]
  },
  {
    path: 'project-index',
    data: {
      title: 'Index'
    },
    component: ViewWithNavBarComponent,
    children: [
      { path: '', component: TableViewComponent }
    ]
  },
  {
    path: 'page',
    component: ViewWithNavBarComponent,
    children: [
      { path: '', component: PageComponent }
    ]
  },
  {
    path: ':category/:subcategory/:page/gallery',
    redirectTo: ':category/:subcategory/:page/gallery/1',
    pathMatch: 'full'
  },
  {
    path: ':category/:page/gallery',
    redirectTo: ':category/:page/gallery/1',
    pathMatch: 'full'
  },
  {
    path: ':category/:page',
    component: ViewWithNavBarComponent,
    children: [
      { path: '', component: PageComponent },
      { path: 'gallery/:index', component: PageComponent },
      { path: 'image/:id', component: PageComponent }
    ]
  },
  {
    path: ':category/:subcategory/:page',
    component: ViewWithNavBarComponent,
    children: [
      { path: '', component: PageComponent },
      { path: 'gallery/:index', component: PageComponent },
      { path: 'image/:id', component: PageComponent }
    ]
  },
  {
    path: ':category/:subcategory/:page/:section',
    component: ViewWithNavBarComponent,
    children: [
      { path: '', component: PageComponent }
    ]
  },
  {
    path: ':page',
    component: ViewWithNavBarComponent,
    children: [
      { path: '', component: PageComponent }
    ]
  }
  // { path: '**', component: PageNotFoundComponent }
    // ]
  // }
];
@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts